import { ClubSlice, StatisticsApi, TasksActions } from '@hefe/store';
import { Select, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import ChartPickerComponent from '../chart-picker/chart-picker.component';
import { t } from '@hefe/i18n';

interface TasksStatisticsComponentProps {
  from: string;
  till: string;
}

export default function TasksStatisticsComponent(
  props: TasksStatisticsComponentProps
) {
  const { from, till } = props;

  const dispatch = useAppDispatch();
  const tasks = useSelector(ClubSlice.clubTasksSelector);

  const [fetchTaskStatistics, { data, isFetching }] =
    StatisticsApi.useLazyFetchTaskStatisticsQuery();

  const [loadingTasks, setLoadingTasks] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState<string | undefined>();

  useEffect(() => {
    fetchTasks();
  }, []);

  useEffect(() => {
    if (selectedTaskId) {
      fetchTaskStatistics({ from, till, taskId: selectedTaskId });
    }
  }, [selectedTaskId, from, till, fetchTaskStatistics]);

  const fetchTasks = () => {
    setLoadingTasks(true);
    dispatch(TasksActions.fetchClubTasks())
      .unwrap()
      .then((data) => setSelectedTaskId(data[0].id))
      .catch(() => undefined)
      .finally(() => setLoadingTasks(false));
  };

  return (
    <div>
      <Space style={{ marginBottom: 24 }}>
        <Typography.Text>{t('tasks.singular')}:</Typography.Text>
        <Select
          loading={loadingTasks}
          options={tasks?.map((task) => ({
            label: task.name,
            value: task.id,
          }))}
          onChange={(value) => setSelectedTaskId(value)}
          value={selectedTaskId}
          style={{ minWidth: 300, maxWidth: '90%' }}
        />
      </Space>
      <ChartPickerComponent charts={data ?? []} loading={isFetching} />
    </div>
  );
}
